export default __webpack_public_path__ + "d1728c59eea66dfa6eb0fc22b9e73380.svg";